import { AiGetExperienceAnalysisHistoryResponseBodyType } from "@intelligems/ig-types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { QueryMeta } from "../../types/react-query";
import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { aiKeys } from "../queryKeys";

export const getExperienceAnalysisHistory = async (experienceId: string) => {
  const resp = await api.get<AiGetExperienceAnalysisHistoryResponseBodyType>(
    `/v2/ai/prompts/experience-analysis-history/${experienceId}`
  );
  return resp.data;
};

export const useExperienceAnalysisHistory = (
  experienceId?: string
): UseQueryResult<AiGetExperienceAnalysisHistoryResponseBodyType, Error> => {
  const org = useGetOrg();
  return useQuery<AiGetExperienceAnalysisHistoryResponseBodyType, Error>({
    queryKey: aiKeys.one(
      org.data.org.id,
      `experience-analysis-history-${experienceId}`
    ),
    retry: false,
    queryFn: async () => getExperienceAnalysisHistory(experienceId!),
    enabled: !!experienceId,
    meta: {
      onError: {
        "503": "ignore",
      },
    } as QueryMeta,
  });
};
